import PropTypes from 'prop-types';
import urls from 'urls';
import {tanzanite} from '../sass/base/_exports.sass';
import {ArrowIcon} from '../svg/ArrowIcon';
import {Button} from './Button';
import {Link} from './Link';

export const BackButton = (props) => {
  const {onClick, href, text = ''} = props;

  const children = (
    <>
      <ArrowIcon className="back-button__icon" ratio={0.5} color={tanzanite} direction="left" />{' '}
      {text}
    </>
  );

  if (href) {
    return (
      <Link data-qa-id="button-guests-back" href={urls.get('my_events')} className="back-button">
        {children}
      </Link>
    );
  }

  return (
    <Button
      variant="link"
      size="large"
      data-qa-id="button-guests-back"
      onClick={onClick}
      className="back-button"
    >
      {children}
    </Button>
  );
};

BackButton.propTypes = {
  onClick: PropTypes.func,
  href: PropTypes.string,
  text: PropTypes.string,
};
